import _ from 'lodash'
import Equipment from 'src/models/Equipment'
import Routine from 'src/models/Routine'

///
/// Generates a text string of all equipment needed for a routine (which is made up of all the
/// equipment used in all the actions within the routine).
///
export const generateRoutineEquipmentString = (
  routine: Routine,
  listType: 'bullet' | 'comma',
): string => {
  const equipment = _.flatMap(routine.actions, (a) => a.equipment)
  return generateEquipmentString(equipment, listType)
}

///
/// Generates a text string of equipment. If no equipment is present then it will return a
/// string with the word "none".
///
/// Second param, listType, indicates whether the list should be a 'bullet' list, or 'comma'
/// list.
///
const generateEquipmentString = (equipment: Equipment[], listType: 'bullet' | 'comma'): string => {
  const equipmentNames = _.map(equipment, ({name}) => name)
  let formatted: string[] = []
  if (listType === 'bullet') {
    const bulleted = _.map(_.uniq(equipmentNames), (name) => `• ${name}`)
    // add newlines for every line except the last
    formatted = _.map(bulleted, (str, i) => `${str}${i < bulleted.length - 1 ? '\n' : ''}`)
  } else {
    // add commas for every name except the last
    formatted = _.map(
      equipmentNames,
      (str, i) => `${str}${i < equipmentNames.length - 1 ? ', ' : ''}`,
    )
  }
  return _.isEmpty(formatted) ? 'None' : formatted.join('')
}

export default generateEquipmentString
